import React from 'react';
import NextImage from 'next/image';

interface ProviderIconProps {
  provider: string;
  className?: string;
  size?: number;
}

export const ProviderIcon: React.FC<ProviderIconProps> = ({ 
  provider, 
  className = "h-4 w-4", 
  size = 16 
}) => {
  const getProviderIcon = (providerName: string) => {
    const normalizedProvider = providerName.toLowerCase();
    
    switch (normalizedProvider) {
      case 'openai':
        return (
          <NextImage src="/ai-models/openai-icon.png" alt="OpenAI" width={size} height={size} />
        );
      
      case 'google':
        return (
          <NextImage src="/ai-models/gemini-icon.png" alt="Google" width={size} height={size} />
        );
      
      case 'anthropic':
        return (
          <NextImage src="/ai-models/anthropic-icon.png" alt="Anthropic" width={size} height={size} />
        );
      
      case 'xai':
        return (
          <NextImage src="/ai-models/xai-icon.png" alt="XAI" width={size} height={size} />
        );
      
      case 'mistral':
        return (
          <NextImage src="/ai-models/mistral-icon.png" alt="Mistral" width={size} height={size} />
        );
      
      case 'cohere':
        return (
          <NextImage src="/ai-models/cohere-icon.png" alt="Cohere" width={size} height={size} />
        );
      
      case 'deepseek':
        return (
          <NextImage src="/ai-models/deepseek-icon.png" alt="DeepSeek" width={size} height={size} />
        );
      
      case 'meta':
        return (
          <NextImage src="/ai-models/meta-icon.png" alt="Meta" width={size} height={size} />
        );
      
      case 'groq':
        return (
          <NextImage src="/ai-models/groq-icon.png" alt="Groq" width={size} height={size} />
        );
      
      default:
        // Fallback to a generic AI icon
        return (
          <NextImage src="/ai-models/generic-icon.png" alt="Generic" width={size} height={size} />
        );
    }
  };

  return (
    <div className={className}>
      {getProviderIcon(provider)}
    </div>
  );
};

// Helper function to get provider color
export const getProviderColor = (provider: string): string => {
  const normalizedProvider = provider.toLowerCase();
  
  switch (normalizedProvider) {
    case 'openai':
      return 'text-green-600 dark:text-green-400';
    case 'google':
      return 'text-blue-600 dark:text-blue-400';
    case 'anthropic':
      return 'text-orange-600 dark:text-orange-400';
    case 'xai':
      return 'text-purple-600 dark:text-purple-400';
    case 'mistral':
      return 'text-indigo-600 dark:text-indigo-400';
    case 'cohere':
      return 'text-pink-600 dark:text-pink-400';
    case 'deepseek':
      return 'text-cyan-600 dark:text-cyan-400';
    case 'meta':
      return 'text-blue-600 dark:text-blue-400';
    case 'groq':
      return 'text-emerald-600 dark:text-emerald-400';
    default:
      return 'text-gray-600 dark:text-gray-400';
  }
};
